module.exports = __webpack_public_path__ + "static/img/sucai.dc9ebc91.png";